import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

export default class StatBlocks {
  $el = null;

  constructor(element) {
    this.$el = $(element);

    if (this.$el.length) {
      this.init();
    }
  }

  init() {
    // Register plugins.
    gsap.registerPlugin(ScrollTrigger);

    this.setupScrollTriggers();
  }

  setupScrollTriggers() {
    const $counters = this.$el.find(".number");
    const $stat = this.$el.find(".stat");
    $counters.each((index, el) => {
      ScrollTrigger.create({
        trigger: $(el),
        start: "top 80%",
        onEnter: () => {
          this.incrementCounter($(el));
        },
        onLeaveBack: (self) => self.disable(),
      });
    });

    $stat.each(function () {
      const $this = $(this);
      gsap.from($this, {
        scale: 0,
        duration: 0.5,
        ease: "back.out(3)",
        scrollTrigger: {
          trigger: $this[0],
          start: "top 90%",
          end: "bottom 10%",
        },
      });
    });
  }

  // Function to increment the counter .number by 0.5 every 10ms
  // until it reaches the value of .number[data-number]
  // This is to make the counter animate
  incrementCounter($counter) {
    let targetNum = $counter.data("number");
    let counter = 0;
    let increment = $counter.data("increment");
    let speed = $counter.data("speed");
    console.log(increment);
    if (increment === 0) {
      increment = 1;
    }

    let counterInterval = setInterval(function () {
      if (counter < targetNum) {
        counter += increment;

        let print = counter;

        if (increment % 1 !== 0) {
          print = counter.toFixed(1);
        }

        if (print > targetNum) {
          print = targetNum;
        }
        console.log($counter);
        $counter.text(print);
      }
    }, speed);
  }
}
